<template>
    <div class="regulations-page">
        <page-hero title="Κανονισμός" eyebrow="The League" compact />
        <div class="cl-page">
            <v-container fluid>
                <v-row>
                    <v-col cols="12">
                        <v-card class="cl-card cl-card--light cl-reading">
                            <span style="text-align: justify;" v-html="regulations.content" />
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    </div>
</template>

<script>
    import PageHero from '@/components/PageHero'
    import configService from '@/services/config'
    export default {
        components: { PageHero },
        data() {
            return {
                regulations: null
            }
        },
        created() {
            this.getRegulations()
        },
        methods: {
            getRegulations() {
                configService.getConfigField('regulation').then(resp => {
                    this.regulations = resp.data
                })
            }
        }
    }
</script>
